module.exports = __webpack_public_path__ + "img/vd.dac15d77.png";